import { setMeData } from "./authActions";

export const loginUser = (email, password, userType, backend_api_base_url) => {
  return async (dispatch) => {
    try {
      // ---- Login API ----
      const response = await fetch(`https://auth2.${backend_api_base_url}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, type: userType }),
      });

      console.log("asfwerresponseer",response)
      if (!response.ok) {
        const err = await response.json();
        console.log("amirthougohr this?",err, response)
        throw new Error(err.error || "Login failed");
      }

      const data = await response.json();

      console.log("ssdfhsafsddata",data)

      if (data == null){

        // throw "Please Correct Your Email/password"
        throw new Error(`Please Correct Your Email/password`);
      }
      else{
     localStorage.setItem("token", data.token);

      // ---- Fetch /me ----
      const meResponse = await fetch(`https://auth2.${backend_api_base_url}/me`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: data.token,
        },
      });

      if (!meResponse.ok) {
        const errText = await meResponse.text();
        throw new Error(`Failed to fetch /me: ${meResponse.status} - ${errText}`);
      }

      const meDataText = await meResponse.text();
      localStorage.setItem("meData", meDataText);

      const meData = JSON.parse(meDataText);

      // ---- Save in Redux ----
      dispatch(setMeData(meData));

      return meData;

      }
 
    } catch (err) {
      throw err;
    }
  };
};
